import { useState } from 'react'
import Styles from './TruncatedText.module.scss'
import { getTruncatedText } from './utils'
import cx from 'classnames'
import { ProseInput } from 'common/ProseInput/ProseInput'

interface TruncatedTextProps {
  text: string
  cardWidth: number
  allowExpand?: boolean
  showMoreButton?: boolean
  totalLines?: number
  isProse?: boolean
}

export const TruncatedText = ({
  text,
  cardWidth,
  allowExpand = true,
  showMoreButton = true,
  totalLines = 2,
  isProse = false,
}: TruncatedTextProps) => {
  const [showMore, setShowMore] = useState(false)
  const truncationLength = cardWidth * totalLines - 50
  let truncatedText = getTruncatedText(text, truncationLength)

  const isTruncated = truncatedText.length < text.length
  if (isTruncated) truncatedText = truncatedText + '...'

  const onMoreButtonClick = () => {
    if (allowExpand) setShowMore(!showMore)
  }

  if (isProse) {
    return (
      <ProseInput
        className={cx(Styles.caption, { [Styles.defaultTruncation]: !showMoreButton })}
        initialHtmlString={showMore ? text : truncatedText}
        isDisabled
      />
    )
  }

  return (
    <>
      <div className={cx(Styles.caption, { [Styles.defaultTruncation]: !showMoreButton })}>
        {showMore ? text : truncatedText}
      </div>
      {isTruncated && showMoreButton && (
        <div
          className={cx(Styles.moreButton, { [Styles.less]: showMore, [Styles.expandable]: allowExpand })}
          onClick={onMoreButtonClick}
        >
          {showMore ? 'less' : 'more'}
        </div>
      )}
    </>
  )
}
